import { cn } from 'lib/helpers/utility';

const ColorDot = ({ selectedColor, disabled, buttonClassName, onOpen }) => {
  return (
    <div
      className={cn(
        'flex size-6 items-center justify-center',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        buttonClassName
      )}
      onClick={onOpen}>
      <div
        className={cn(
          'size-[18px] rounded-full',
          selectedColor === '#ffffff' && 'border border-solid border-neutral-200'
        )}
        style={{ background: selectedColor }}
      />
    </div>
  );
};

export default ColorDot;
